import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Heading from '../../common/Heading/head';
import { isMobile, isPreorder, isWHW, isWHWP2, isWWM } from '../../common/Helpers/index';

const ShippingHeader = ({ heading, headingPreorder, gettingShippingOptionHeader }) => {
  useEffect(() => {
    gettingShippingOptionHeader(isPreorder() ? headingPreorder : heading);
  }, []);
  return (
    <Heading
      heading={isPreorder() ? headingPreorder : heading}
      className={(isWHW() ||isWHWP2()) ||isWWM() && !isMobile() ? 'margin30 onlyBottomMarginImp' : ' '}
      width={isMobile() ? '341px' : ''}
    />
  );
};

ShippingHeader.propTypes = {
  heading: PropTypes.string,
  headingPreorder: PropTypes.string,
  gettingShippingOptionHeader: PropTypes.func,
};

export default React.memo(ShippingHeader);
